import { convertToRaw } from "draft-js";
import { SECTIONS } from "../config/constants";
import { RUBRICS, TEMPLATES } from "../config/constants/editor";

export default function getJsonState(form) {
  const body = {};

  for (let key in form) {
    switch (key) {
      case "content":
        body.blocks = convertToRaw(form.content.getCurrentContent());
        break;

      case "intro":
      case "outro":
        body[key] = convertToRaw(form[key].getCurrentContent());
        break;

      case "sections":
        if (form.isTopStory) {
          body.sections = [SECTIONS.TOP, ...form.sections];
        } else {
          body.sections = form.sections;
        }
        break;

      case "rubric":
        if (form.rubric.id === RUBRICS.DEFAULT.id) {
          body.rubric = null;
        } else {
          body.rubric = form.rubric;
        }
        break;

      case "template":
        if (form.template.id === TEMPLATES.DEFAULT.id) {
          body.template = null;
        } else {
          body.template = form.template;
        }
        break;

      case "isTopStory":
        break;

      case "primary_image":
      case "social_image":
        if (form[key]) {
          body[key] = form[key].id;
        } else {
          body[key] = form[key];
        }
        break;

      case "scheduled_date":
      case "eta":
        body[key] = form[key] ? form[key].toISOString() : null;
        break;

      case "chunks": {
        body.chunks = form.chunks.map(chunk => {
          const newChunk = {};
          for (let key in chunk) {
            switch (key) {
              case "blocks":
                newChunk.blocks = convertToRaw(
                  chunk.blocks.getCurrentContent()
                );
                break;

              case "primary_image":
                // I hate myself.
                if (chunk.primary_image) {
                  newChunk.primary_image = chunk.primary_image.id;
                } else {
                  newChunk.primary_image = chunk.primary_image;
                }
                break;

              case "tempKey":
                break;
              case "rubric":
                if (chunk.rubric === RUBRICS.DEFAULT) {
                  newChunk.rubric = null;
                } else {
                  newChunk.rubric = chunk.rubric;
                }
                break;

              default:
                newChunk[key] = chunk[key];
            }
          }
          return newChunk;
        });
        break;
      }

      default:
        body[key] = form[key];
        break;
    }
  }
  return body;
}
